import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_STATUS,
  RESET_STATUS,
  SET_ERROR,
  FETCH_SETTINGS_SUCCESS,
  FETCH_STORES_SUCCESS,
  SET_UPDATE_LOADING,
  SET_ACTIONS_LOADING,
  FETCH_ACTIONS_SUCCESS,
  EDIT_STORE_SUCCESS
} from "./storesSagas";

export const initialState = {
  isLoading: true,
  areStoresLoading: true,
  actionsLoading: true,
  status: "idle",
  errors: null,
  stores: null,
  commonSettings: { chains: [], organizations: [] },
  currentStoreActions: {}
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [RESET_STATUS]: (state) => ({
      ...state,
      status: "idle",
      errors: null,
      currentStoreInfo: null
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATE_LOADING]: (state, action) => ({
      ...state,
      areStoresLoading: action.payload
    }),
    [SET_ACTIONS_LOADING]: (state, action) => ({
      ...state,
      actionsLoading: action.payload
    }),
    [FETCH_SETTINGS_SUCCESS]: (state, action) => ({
      ...state,
      commonSettings: action.payload
    }),
    [FETCH_STORES_SUCCESS]: (state, { payload: { stores } }) => ({
      ...state,
      stores
    }),
    [FETCH_ACTIONS_SUCCESS]: (state, action) => ({
      ...state,
      currentStoreActions: action.payload
    }),
    [EDIT_STORE_SUCCESS]: (state, { payload: { id, data } }) => ({
      ...state,
      status: "success",
      stores: {
        ...state.stores,
        [data.organizationName]: state.stores[data.organizationName].map((store) =>
          store.id == id ? { ...store, name: `${data.name} (${data.remoteUid})` } : store
        )
      }
    })
  },

  initialState
);
